import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { map, pluck } from 'rxjs/operators';
 
@Injectable({
  providedIn: 'root'
})
export class JobDescriptionLcaWorkLibraryService {
 
  constructor(private httpClient: HttpClient) { }
 
  getLcaById(id) {
    return this.httpClient.get(`/dashboard/petitioner/lca/${id}`).pipe(
      pluck('data'),
      map((codes: Array<any>) => {
        return codes;
      })
    )
  }
}